import React from 'react';

import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Box, Chip, Divider, List, ListItem, Typography, styled } from '@mui/material';

const CustomBox = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const CandidateInfos = ({ contact }) => {
  const contactInfo = contact.contactsInfos.find(infos => infos.sources && infos.sources.source === 'SALESFORCE');
  const profilDoc = contactInfo.document.find(doc => doc.category === 'PROFIL');
  const avatarUrl = profilDoc?.public_url;
  const company = contactInfo?.company || contact?.contactsInfos[0]?.company;
  const bu = company.code.toLowerCase();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar sx={{ width: 95, height: 95 }}>
          {avatarUrl ? (
            <Box component='img' src={avatarUrl} alt='avatar' />
          ) : (
            <Box sx={{ fontSize: '2rem' }}>
              <FontAwesomeIcon icon={faUser} />
            </Box>
          )}
        </Avatar>
        <Box sx={{ marginLeft: '20px' }}>
          <Typography variant='h6' gutterBottom>
            {contactInfo.firstname}{' '}
            <Box component='span' sx={{ fontWeight: '700', wordBreak: 'break-word' }}>
              {contactInfo.name}
            </Box>
          </Typography>
          <Chip size='small' label={company.name} sx={{ bgcolor: theme => theme.palette[bu].main, color: '#fff' }} />
        </Box>
      </Box>
      <List>
        <ListItem disableGutters>
          <CustomBox>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FontAwesomeIcon icon={faPhone} />
              <Typography variant='subtitle1' sx={{ marginLeft: '5px' }}>
                Téléphone
              </Typography>
            </Box>
            <Typography variant='body2'>{contactInfo.phone}</Typography>
          </CustomBox>
        </ListItem>
        <Divider component='li' />
        <ListItem disableGutters>
          <CustomBox>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FontAwesomeIcon icon={faEnvelope} />
              <Typography variant='subtitle1' sx={{ marginLeft: '5px' }}>
                Email
              </Typography>
            </Box>
            <Typography variant='body2'>{contact.email}</Typography>
          </CustomBox>
        </ListItem>
        <Divider component='li' />
        <ListItem disableGutters>
          <CustomBox>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FontAwesomeIcon icon={faLocationDot} />
              <Typography variant='subtitle1' sx={{ marginLeft: '5px' }}>
                Adresse
              </Typography>
            </Box>
            <Typography variant='body2' textAlign={'right'}>
              {contactInfo.address} <br /> {contactInfo.zipcode} {contactInfo.city}
            </Typography>
          </CustomBox>
        </ListItem>
      </List>
    </>
  );
};

export default CandidateInfos;
